'use client'

import React, { useEffect, useMemo } from 'react'
import { PatternFormat } from 'react-number-format'

import { normalizeErrorSimple } from '@rewardops/utils/src/form-utils'

import { cn } from '../lib/utils'
import { inputVariants, Label } from '../shad'
import { type InputFieldProps } from './input-field'

const MaskField = ({
  name,
  format,
  mask = '_',
  label,
  disabled,
  type = 'text',
  className,
  formConsts,
  initialValue,
  registerOptions = {},
}: InputFieldProps & { mask?: string; format: string }) => {
  const error = normalizeErrorSimple(name, formConsts?.errors?.[name]?.message)
  const field = useMemo(() => {
    return { ...formConsts?.register(name, registerOptions) }
  }, [formConsts, name, registerOptions])

  useEffect(() => {
    field.onChange({ target: { name, value: initialValue } })
  }, [name])

  return (
    <div
      className={cn('mb-3 w-full', { hidden: type === 'hidden' }, className)}
    >
      <div className="h-full w-full items-center">
        <Label htmlFor={name}>{label}</Label>

        <PatternFormat
          className={cn(inputVariants())}
          aria-label={label}
          defaultValue={initialValue}
          format={format}
          mask={mask}
          disabled={disabled}
          onBlur={() => {
            // Run field validation
            formConsts?.trigger(name)
          }}
          onValueChange={({ value }) => {
            // Convert to a pseudo event
            field.onChange({ target: { name, value } })
          }}
          allowEmptyFormatting
        />

        {error ? (
          <p className="mt-2 px-1 text-xs text-red-600">{error}</p>
        ) : undefined}
      </div>
    </div>
  )
}

export { MaskField }
